.root {
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 12px;
}
